export function whenIdle() {
    return new Promise((resolve) => {
        if (window.requestIdleCallback != null) {
            window.requestIdleCallback(resolve)
        } else {
            setTimeout(resolve, 0)
        }
    })
}

export function waitForAnimationFrame() {
    return new Promise((resolve) => {
        if (window.requestAnimationFrame != null) {
            window.requestAnimationFrame(resolve)
        } else {
            setTimeout(resolve, 0)
        }
    })
}
